export default __webpack_public_path__ + "images/6af647f5f34524566477e48f82e08af9-Industry-Medium.woff";